import { Badge, Box, Checkbox, Heading, Image } from '@wix/design-system'
import React, { FC, memo, useCallback } from 'react'

import { RichText } from '../../../reusable/RichText'
import { Option } from '../Content'
import { dataHooks } from './AppItem.dataHooks'
import s from './AppItem.scss'

export type AppItemOnClick = (params: { option: Option; checked: boolean; index: number }) => void

type AppItemProps = {
  option: Option
  checked: boolean
  index: number
  onClick?: AppItemOnClick
  builtInLabel: string
  dataHook?: string
}

export const AppItem: FC<AppItemProps> = memo(({ option, checked, index, onClick, builtInLabel, dataHook }) => {
  const { name, icon, description, level } = option

  const isBuiltIn = level === 'built-in'

  const handleClick = useCallback(() => onClick?.({ option, checked, index }), [onClick, option, checked, index])

  const nameWithCheckbox = (
    <Box height="24px" direction="horizontal" gap="12px" verticalAlign="middle" marginBottom="12px">
      {!isBuiltIn && (
        <Box marginRight="12px">
          <Checkbox checked={checked} dataHook={dataHooks.checkbox()} />
        </Box>
      )}
      <Box width="24px" height="24px">
        <Image src={icon} borderRadius="3px" dataHook={dataHooks.image()} />
      </Box>
      <Box>
        <Heading size="medium" dataHook={dataHooks.name()}>
          {name}
        </Heading>
      </Box>
      {isBuiltIn && (
        <Box marginLeft="12px">
          <Badge type="solid" skin="neutralStandard" uppercase dataHook={dataHooks.builtInLabel()}>
            {builtInLabel}
          </Badge>
        </Box>
      )}
    </Box>
  )

  return (
    <div className={`${s.appItem} ${checked ? s.checked : ''}`} onClick={handleClick}>
      <Box padding="24px 0px 18px" direction="vertical" dataHook={dataHook}>
        {nameWithCheckbox}
        <RichText className={s.description} dataHook={dataHooks.description()}>
          {description}
        </RichText>
      </Box>
    </div>
  )
})
